export default __webpack_public_path__ + "static/trend-01761e4e70e645c8c3d3cbdf23fb40f5.png";